import {BaseSyntheticEvent} from "react";
import {FormProvider, SubmitHandler, useForm, UseFormGetValues} from "react-hook-form";
import {SubmitErrorHandler} from "react-hook-form";

import {IPreferencesDefaultValues} from "../../types/IPreferencesDefaultValues";

type SubmitHandlerType = (
    onValid: SubmitHandler<IPreferencesDefaultValues>,
    onInvalid?: SubmitErrorHandler<IPreferencesDefaultValues>
) => (e?: BaseSyntheticEvent) => Promise<void>;

interface IProps {
    defaultValues: IPreferencesDefaultValues | null;
    children: (handleSubmit: SubmitHandlerType, getValues?: UseFormGetValues<IPreferencesDefaultValues>) => React.ReactNode;
}

export const UserPreferencesFormProvider = (props: IProps) => {
    const {defaultValues, children} = props;

    const formMethods = useForm({defaultValues: defaultValues || {}});

    return <FormProvider {...formMethods}>{children(formMethods.handleSubmit, formMethods.getValues)}</FormProvider>;
};
import {BaseSyntheticEvent} from "react";
import {FormProvider, SubmitHandler, useForm, UseFormGetValues} from "react-hook-form";
import {SubmitErrorHandler} from "react-hook-form";

import {IPreferencesDefaultValues} from "../../types/IPreferencesDefaultValues";

type SubmitHandlerType = (
    onValid: SubmitHandler<IPreferencesDefaultValues>,
    onInvalid?: SubmitErrorHandler<IPreferencesDefaultValues>
) => (e?: BaseSyntheticEvent) => Promise<void>;

interface IProps {
    defaultValues: IPreferencesDefaultValues | null;
    children: (handleSubmit: SubmitHandlerType, getValues?: UseFormGetValues<IPreferencesDefaultValues>) => React.ReactNode;
}

export const UserPreferencesFormProvider = (props: IProps) => {
    const {defaultValues, children} = props;

    const formMethods = useForm({defaultValues: defaultValues || {}});

    return <FormProvider {...formMethods}>{children(formMethods.handleSubmit, formMethods.getValues)}</FormProvider>;
};
